import mvtArticle from '@/common/components/mvtarticle/mvt-article.vue';
import { articleMap } from '@/common/constants/articleMap.js';
import mvtFaq from '@/common/components/mvtfaq/mvt-faq.vue';
import faqConf from '@/common/store/glb/data.faqs';
import mortgageTools from '@/staticpages/components/common/mortgagetools/mortgagetools.vue';
import compareRates from '@/staticpages/components/comparerates/comparerates.vue';
import { defineAsyncComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';
const mvtRateTrend = defineAsyncComponent(() => import(/* webpackChunkName: "rateTrend" */ '@/common/components/mvtratetrend/mvt-ratetrend.vue'));

export default {
    name: 'pageMortgagerates',
    inject: ['$eventBus'],
    components: {
        mvtDialogCenter,
        compareRates,
        mvtArticle,
        mvtFaq,
        mvtRateTrend,
        mvtHeader,
        mortgageTools,
        mvtFooter,
        mvtLazyload,
    },
    data() {
        return {
            tag: null,
            faqQuery: null,
        };
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb']),
    },
    methods: {
        ...mapActions('glb', ['fetchArticleFeeds', 'fetchFAQs']),
    },
    mounted() {
        this.tag = articleMap.tag.mortgageRates;
        this.faqQuery = faqConf.mortgageRates;
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
};
